export default "__VITE_ASSET__666ba2d1__"